import React, { useRef, useState } from 'react'
import classes from './Sort.module.css'
import { ReactComponent as OptionsIcon } from '../../../assets/icons/options.svg'
import { ReactComponent as DownIcon } from '../../../assets/icons/down-caret.svg'
import classNames from 'classnames'
import { useHideOnClickOutside } from '../../../hooks/useHideOnClickOutside'

const Sort = ({ options, sort, setSort }) => {
    const [active, setActive] = useState(false)

    const optionsRef = useRef()

    useHideOnClickOutside({
        hide: _ => setActive(false),
        el: optionsRef.current,
        open: active,
    })

    return (
        <div>
            <button className={classes.sortBy} onClick={_ => setActive(true)}>
                <OptionsIcon className={classes.sortByOptionsIcon} />
                <span className={classes.sortByText}>Sort By: {sort}</span>
                <DownIcon className={classes.sortByDropdownIcon} />
            </button>
            <div
                className={classNames(
                    classes.sortOptions,
                    active && classes.sortOptionsActive
                )}
                ref={optionsRef}
            >
                {options.map(({ text, id }) => (
                    <button
                        key={id}
                        className={classes.sortOption}
                        onClick={() => {
                            setSort(id)
                            setActive(false)
                        }}
                    >
                        {text}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default Sort
